import { ThemeProvider } from "@mui/material";
import { CbhFeatureFlag } from "@src/appV2/FeatureFlags/CbhFeatureFlag";
import { FEATURE_FLAG_DEFAULT_VALUES } from "@src/appV2/FeatureFlags/constants";
import { useCbhFlag } from "@src/appV2/FeatureFlags/useCbhFlag";
import { getTheme } from "@src/appV2/redesign/system/ui-theme";
import { useGetWorker } from "@src/appV2/Worker/api/useGetWorker";

import { PostShiftReviewFlow } from "../PostShiftReviewFlow";
import { LEAVE_REVIEW_ENTRYPOINT } from "../types";
import { useDelayedReview } from "./useDelayedReview";

/**
 * Container for the delayed workplace review feature.
 * Renders on the shift-discovery page only (controlled by route placement).
 * Shows a workplace review modal 120+ minutes after shift end when worker is not in an active shift.
 */
export function DelayedReviewContainer() {
  const { data: worker } = useGetWorker();

  const config = useCbhFlag(CbhFeatureFlag.DELAYED_WORKPLACE_REVIEW, {
    defaultValue: FEATURE_FLAG_DEFAULT_VALUES[CbhFeatureFlag.DELAYED_WORKPLACE_REVIEW],
  });

  const { activeReview, modalState, onComplete } = useDelayedReview({
    isEnabled: config.enabled,
    delayMinutes: config.delayMinutes,
    workerTimezone: worker?.tmz,
  });

  if (!activeReview) {
    return null;
  }

  return (
    <ThemeProvider theme={getTheme()}>
      <PostShiftReviewFlow
        isDelayedReview={config.useDelayedReviewUI}
        modalState={modalState}
        facility={{
          id: activeReview.facilityId,
          name: activeReview.facilityName,
          type: activeReview.facilityType,
          photo: undefined,
        }}
        shiftId={activeReview.shiftId}
        source={LEAVE_REVIEW_ENTRYPOINT.DELAYED_REVIEW}
        onComplete={onComplete}
      />
    </ThemeProvider>
  );
}
